import VisibilityOff from '@material-ui/icons/VisibilityOffOutlined';
import Visibility from '@material-ui/icons/VisibilityOutlined';

type VisibilityIconProps = {
  visible: boolean;
};

export const VisibilityIcon: React.FC<VisibilityIconProps> = ({ visible }) => {
  return (
    <>
      {!visible && <VisibilityOff style={{ color: '#535353' }} />}
      {visible && <Visibility style={{ color: '#535353' }} />}
    </>
  );
};
